module.exports = __webpack_public_path__ + "img/PDM-600-Mobile-Trafo1.496e2d4b.webp";